<template>
  <h2>{{$t("about." + type + ".title")}}</h2>

  <template v-for="(block, index) in blocks" :key="index">
    <p v-if="block.p">
      <template v-for="(part, partIndex) in withLinks($rt(block.p))" :key="partIndex">
        <a v-if="links[part]" :href="links[part]" target="_blank" rel="noopener">{{part}}</a>
        <template v-else>{{part}}</template>
      </template>
    </p>
    <p v-else-if="block.strong"><strong>{{$rt(block.strong)}}</strong></p>
    <ul v-else-if="block.ul">
      <li v-for="(item, itemIndex) in block.ul" :key="itemIndex">{{$rt(item)}}</li>
    </ul>
  </template>
</template>

<script lang="ts">

// Cada bloco do texto "sobre" é um parágrafo (p), um destaque em negrito (strong) ou uma lista (ul).
interface AboutBlock {
  p?: any
  strong?: any
  ul?: any[]
}

// Nomes das bases de constantes que viram link no texto (como nos documentos originais).
const links: Record<string, string> = {
  ULIB: "http://ocusoft.de/ulib/c1.htm",
  IOLCon: "https://iolcon.org/lensesTable.php"
}

export default {
  props: {
    type: String
  },
  data() {
    return { links }
  },
  methods: {
    withLinks(text: string): string[] {
      return text.split(/(ULIB|IOLCon)/)
    }
  },
  computed: {
    blocks(): AboutBlock[] {
      return this.$tm("about." + this.type + ".blocks") as AboutBlock[]
    }
  }
}
</script>
